export const _en = {
    filter: {
        expand: {
            label: "More filters"
        },
        reduce: {
            label: "Less filters"
        },
        placeholder: "Filters"
    },
    associationBtn: {
        label: "Combine a skill"
    },
    actionsColumn: {
        label: "Action(s)"
    },
    skillSelect: {
        placeholder: "Select a skill"
    }

};

export const _fr = {
    filter: {
        expand: {
            label: "Plus de filtres"
        },
        reduce: {
            label: "Moins de filtres"
        },
        placeholder: "Filtre"
    },
    associationBtn: {
        label: "Associer une compétence"
    },
    actionsColumn: {
        label: "Action(s)"
    },
    skillSelect: {
        placeholder: "Sélectionnez une compétence"
    }
};